export default __webpack_public_path__ + "static/client-testimonial-8a467f308b14513d5f874d6d4e70425c.jpg";